/* Existing recommendation mapping retained. No answer data leaves the browser. */
(function(){
 function initialize(root){
 root.querySelectorAll('.lj-farbwelt').forEach(function(section){
  if(section.dataset.advisorReady)return;section.dataset.advisorReady='true';
  var form=section.querySelector('.lj-berater-form');if(!form)return;
  var out=section.querySelector('.lj-berater-result'),progress=form.querySelector('.lj-berater-progress');
  var config=JSON.parse(section.querySelector('[data-advisor-config]').textContent);
  var fields=[].slice.call(form.querySelectorAll('fieldset'));
  var colors={};
  section.querySelectorAll('.lj-farb-tile').forEach(function(a){
   var key=a.dataset.colorKey;
   colors[key]={name:a.querySelector('.lj-farb-name').textContent,url:a.href,image:a.querySelector('img').src};
  });
  var TYP={
   fruehling:{name:'Frühlingstyp',text:'Dir stehen klare, leuchtende Farben mit einem warmen Unterton. Alles, was frisch und sonnig wirkt, bringt deinen Teint zum Strahlen. Gelbgold unterstreicht das zusätzlich.',farben:['tuerkis','rosa','warm-bunt','gruen']},
   sommer:{name:'Sommertyp',text:'Dir schmeicheln weiche, kühle Farben mit etwas Grauanteil – nichts zu Grelles. Silber und Roségold passen besonders gut dazu.',farben:['rosa','lila','blau','klar-weiss']},
   herbst:{name:'Herbsttyp',text:'Warme, tiefe Naturtöne sind deine Farben: alles, was an Gewürze, Holz und Laub erinnert. Gelbgold passt wunderbar dazu.',farben:['braun-beige','gruen','warm-bunt','klar-weiss']},
   winter:{name:'Wintertyp',text:'Du verträgst klare, kräftige Kontraste und kühle Töne. Reines Weiß, tiefes Blau und Schwarz wirken an dir besonders edel – am besten mit Silber.',farben:['klar-weiss','blau','lila','schwarz-grau']}
  };
  function update(){
   var count=fields.filter(function(f){return f.querySelector('input:checked')}).length;
   progress.textContent=count+' '+config.progress_label;
   fields.forEach(function(f){f.removeAttribute('aria-invalid')});
  }
  Object.keys(TYP).forEach(function(k){TYP[k].name=config[k+'_name'];TYP[k].text=config[k+'_text']});
  section.querySelectorAll('[data-jewel-key]').forEach(function(i){if(colors[i.dataset.jewelKey])i.src=colors[i.dataset.jewelKey].image});
  form.addEventListener('change',function(){update();out.hidden=true;out.replaceChildren()});
  form.addEventListener('submit',function(e){
   e.preventDefault();var d=new FormData(form),ton=d.get('ton'),met=d.get('metall'),kon=d.get('kontrast');
   out.replaceChildren();out.hidden=false;
   if(!ton||!met||!kon){
    var p=document.createElement('p');p.textContent=config.error_text;out.append(p);
    fields.filter(function(f){return !f.querySelector('input:checked')}).forEach(function(f){f.setAttribute('aria-invalid','true')});
    var first=form.querySelector('fieldset[aria-invalid=true] input');if(first)first.focus();return;
   }
   var w=0;if(ton==='warm')w++;if(ton==='kuehl')w--;if(met==='warm')w++;if(met==='kuehl')w--;
   var warm=w>0;if(w===0)warm=kon!=='tief';
   var tief=kon==='tief'||(kon==='mittel'&&!warm);
   var key=warm?(tief?'herbst':'fruehling'):(tief?'winter':'sommer'),t=TYP[key];
   var eyebrow=document.createElement('p');eyebrow.className='lj-result-eyebrow';eyebrow.textContent=config.result_kicker;
   var h=document.createElement('h4');h.textContent=t.name;
   var copy=document.createElement('p');copy.textContent=t.text;
   var links=document.createElement('div');links.className='lj-berater-links';
   t.farben.forEach(function(k){var c=colors[k];if(!c)return;
    var a=document.createElement('a');a.href=c.url;
    if(section.dataset.preview==='true'){a.target='_blank';a.rel='noopener'}
    var img=document.createElement('img');img.src=c.image;img.alt='';img.width=88;img.height=88;img.className='lj-farb-stone';
    var name=document.createElement('span');name.textContent=c.name;a.append(img,name);links.append(a);
   });
   var reset=document.createElement('button');reset.type='button';reset.className='lj-berater-reset';reset.textContent=config.reset_label;
   reset.addEventListener('click',function(){form.reset();update();out.hidden=true;out.replaceChildren();form.querySelector('input').focus()});
   out.append(eyebrow,h,copy,links,reset);out.focus({preventScroll:true});
   out.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'nearest'});
  });
  update();
 });
 }
 initialize(document);
 if(!window.ljAdvisorSectionListener){window.ljAdvisorSectionListener=true;document.addEventListener('shopify:section:load',function(e){initialize(e.target)})}
})();
